import { Container, Sprite, Graphics, Text, TextStyle } from 'pixi.js'
import { FT } from 'ft'

const $frame = 'bed-temp-frame'
const $bar = 'bed-temp-bar'
const $bg = 'bed-temp-bg'

FT.rm.addImage($frame)
FT.rm.addImage($bar)
FT.rm.addImage($bg)

const normalStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#ffffff',
})

const usernameStyle = new TextStyle({
  fontFamily: 'sans-serif',
  fontSize: 34,
  fill: '#ffffff',
})

class Thermograph extends Container {
  constructor(username, temp) {
    super()

    const { rm } = FT
    const user = new Text(username, usernameStyle)
    user.anchor.set(0, 0.5)
    const description = new Text('的被窝正在发热……', normalStyle)
    description.anchor.set(0, 0.5)
    description.x = user.width + 5

    const bg = new Sprite(rm.texture($bg))
    bg.x = 3
    bg.y = 36
    const bar = new Sprite(rm.texture($bar))
    this.bar = bar
    bar.x = 3
    bar.y = 36
    const frame = new Sprite(rm.texture($frame))
    frame.y = 33

    const mask = new Graphics()
    mask.beginFill(0x66ccff)
    mask.drawRect(3, 36, bar.width, bar.height)
    mask.endFill()
    bar.mask = mask
    this.progress = mask

    const record = new Text('', normalStyle)
    this.record = record
    record.y = 105

    this.addChild(user)
    this.addChild(description)
    this.addChild(bg)
    this.addChild(bar)
    this.addChild(frame)
    this.addChild(mask)
    this.addChild(record)

    this.render(temp)
  }

  render(temp) {
    const MAX = 40
    const width = (temp / MAX) * this.bar.width
    this.progress.width = width <= this.bar.width ? width : this.bar.width

    this.record.text = `当前温度${temp.toFixed(0)}°C`
  }
}

export default Thermograph
